import { Component, OnInit, ViewChild } from '@angular/core';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  
  userid ="";
  hash="";
  constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private activatedRouter:ActivatedRoute,private router:Router) {
    this.activatedRouter.params.subscribe((params: Params) => {
      this.userid = params['id'];
      this.hash = params['hash'];
      
    });
   }

  ngOnInit() {
    // alert(this.userid);
    // alert(this.hash);
  }

  resetpassword(resetpasswordForm: NgForm)
  {
    let body = new FormData();
    if(resetpasswordForm.value.password && resetpasswordForm.value.confirmpassword)
    {
      if(resetpasswordForm.value.password != resetpasswordForm.value.confirmpassword)
      {
        this.snackbar.open('Passwords Mismatch', null, {
          duration:5000,
            extraClasses:'error-snackbar',
            verticalPosition:'top'
          });
      }
      else
      {
        body.append('password', resetpasswordForm.value.password);
        body.append('confirmpassword', resetpasswordForm.value.confirmpassword);
        body.append('userid', this.userid);
        body.append('hash', this.hash);
        
        this.http.post(this.helper.base_url+'http/resetpassword', body)
        .subscribe(
          (res) => {
          //let user=JSON.parse(res['_body'])[0];
          let body = JSON.parse(res['_body']);
          if(body.success == 0)
          {
            this.snackbar.open(body.message, null, {
              duration:7000,
              extraClasses:'error-snackbar',
              verticalPosition:'top'
            });
            this.router.navigate(["/login"]);
          }
          else
          {
            this.snackbar.open(body.message, null, {
              duration:7000,
              extraClasses:'error-snackbar',
              verticalPosition:'top'
            });
          }
            //   if(res['_body']!="0") {

            //   // this.cookie.put('auth','Y');
            //   // this.cookie.put('user_id',user.id);
            //   // this.cookie.put('user_image',user.image);

            //   this.snackbar.open('Please Check Your Mail For Reset Link', null, {
            //   duration:7000,
            //     extraClasses:'success-snackbar',
            //     verticalPosition:'bottom'
            //   });
            //     //this.router.navigate(["/dashboard"]);
            // }else{
            //   this.snackbar.open('Wrong Credantials', null, {
            //     duration:5000,
            //     extraClasses:'error-snackbar',
            //     verticalPosition:'bottom'
            //   });
            // }
          }, //For Success Response
            err => {console.error(err)} //For Error Response);
        );
        
      }
    }
    else
    {
      this.snackbar.open('Fill All Fields', null, {
        duration:5000,
          extraClasses:'error-snackbar',
          verticalPosition:'top'
        });
    }
  }
  forgot(forgotpassword: NgForm){
    let body = new FormData();
    
    //alert(forgotpassword.value.email);
    if(forgotpassword.value.email)
    {
      body.append('email', forgotpassword.value.email);
      this.http.post(this.helper.base_url+'http/forgotpassword', body)
      .subscribe(
        (res) => {
        let user=JSON.parse(res['_body'] )[0] ;
        if(res['_body']!="0") {

        // this.cookie.put('auth','Y');
        // this.cookie.put('user_id',user.id);
        // this.cookie.put('user_image',user.image);

        this.snackbar.open('Please Check Your Mail For Reset Link', null, {
        duration:7000,
          extraClasses:'success-snackbar',
          verticalPosition:'top'
        });
          //this.router.navigate(["/dashboard"]);
      }else{
        this.snackbar.open('Wrong Credantials', null, {
        duration:5000,
          extraClasses:'error-snackbar',
          verticalPosition:'top'
        });
      }
        }, //For Success Response
          err => {console.error(err)} //For Error Response);
      );
    }
    else
    {
      this.snackbar.open('Provide an email', null, {
          duration:5000,
            extraClasses:'error-snackbar',
            verticalPosition:'top'
          });
    }

    }

}



// WEBPACK FOOTER //
// ./src/app/reset-password/reset-password.component.ts